module.exports = __webpack_public_path__ + "static/media/pin-success.82ddbcbd.png";